import React from "react";

export default function (props) {

    const btnClassType = props.isEditing ? "btn-primary" : "btn-default";
    const value = !props.value ? null : (
        <small>
            <span className="pull-right">{props.value}</span>
        </small>
    );

    return (
        <div>
            <a tabIndex="0" className={"fullwidth btn "+btnClassType} onClick={props.onClick}>
                <span>
                    <span className={value===null ? "" : "pull-left"}>
                        {props.name}
                    </span>
                    {value}
                </span>
            </a>
        </div>
    );
}



// WEBPACK FOOTER //
// ./src/js/TagPropertyButton.js